import { createApp } from 'vue';
import allpaabaCollectionGrid from '../../../vue/collections/allpa/allpaaba-collection-grid.vue';

if (document.getElementById('vue-allpaaba-collection-grid')) {
  createApp(allpaabaCollectionGrid, { collectionId }).mount(
    '#vue-allpaaba-collection-grid'
  );
}
